import { useEffect, useState } from "react";
import ImageUploadIcon from "../../assets/svg/ImageUploadIcon";
import CustomText from "../atomic/CustomText";

const DragAndDropImage: React.FC<{ disabled?: boolean }> = ({ disabled }) => {
  return (
    <div className={`w-32 h-32 border-2 bg-sideNavGray border-dashed border-borderGray rounded-full flex items-center justify-center text-center ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} text-gray-600`}>
      <div className={`flex flex-col items-center`}>
        <ImageUploadIcon className={`w-6 h-6`} />
        <p className="mt-2 text-sm">
          <CustomText text={"Drag & Drop"} fontWeight="font-medium"/>
          <CustomText
            text={"Image"}
            fontWeight="font-medium"
            className="mt-1 "
          />
        </p>
      </div>
    </div>
  );
};

function CustomImage({
  src,
  alt,
  className,
  ImageUpload,
  disabled
}: {
  src: string;
  alt: string;
  className?: string;
  ImageUpload?: boolean;
  disabled?: boolean
}) {
  const [error, setError] = useState<boolean>(false);

  function handleError() {
    setError(true);
  }

  function onLoad() {
    setError(false);
  }

  useEffect(() => {
    setError(false);
  }, [src]);
  if (error || src === "") {
    if (ImageUpload) {
      return <DragAndDropImage disabled={disabled}/>;
    }
    return (
      <img
        src={require(alt === "Signature"
          ? "../../assets/images/SignatureImage.png"
          : "../../assets/images/NoImage.png")}
        className={className ?? "object-contain w-[7rem] h-[7rem] rounded-full"}
      />
    );
  }

  return (
    <img
      onError={handleError}
      onLoad={onLoad}
      src={src}
      alt={alt}
      className={className ?? "object-fit w-[7rem] h-[7rem] rounded-full"}
    />
  );
}

export default CustomImage;
